export default function ArrowRightIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 21 21'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.83325 10.4998C3.83325 10.0396 4.20635 9.6665 4.66659 9.6665H16.3333C16.7935 9.6665 17.1666 10.0396 17.1666 10.4998C17.1666 10.9601 16.7935 11.3332 16.3333 11.3332H4.66659C4.20635 11.3332 3.83325 10.9601 3.83325 10.4998Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.91083 4.07757C10.2363 3.75214 10.7639 3.75214 11.0893 4.07757L16.9227 9.91091C17.2481 10.2363 17.2481 10.764 16.9227 11.0894L11.0893 16.9228C10.7639 17.2482 10.2363 17.2482 9.91083 16.9228C9.58539 16.5973 9.58539 16.0697 9.91083 15.7442L15.1549 10.5002L9.91083 5.25609C9.58539 4.93065 9.58539 4.40301 9.91083 4.07757Z'
        />
      </svg>
    </span>
  );
}
